const stringPad = (order_id) => {
  return String(order_id).padStart(5, '0');
};

export { stringPad };
